export default __webpack_public_path__ + "static/media/gallery4.06a98e33.jpeg";